import React from 'react';
import './Risk.scss'
import { Lists, HeaderSwiper } from '@/components/mixins'
import '../../common/common.scss'
import { RelatedCases } from '@/components'
class Risk extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      headerDataLists: [
        { imgPath: require("img/Products/riskbanner.png"), imgHDPath: `${require("img/Products/riskbanner.png")} 1x,${require("img/Products/riskbanner@2x.png")} 2x,${require("img/Products/riskbanner@3x.png")} 3x`, attachURL: "/" }
      ],
      dataLists: [
        {
          title: '管控体系建设',
          data: '我们帮助集团客户建立基建管控体系，包括组织机构及其权责、工作流程、信息沟通与工作表单、制度与规范，以实现建设项目标准化、规范化的管理，并有效规避投资失控的风险。',
          imgPath: require("img/Products/riskpic1.png"), imgHDPath: `${require("img/Products/riskpic1.png")} 1x,${require("img/Products/riskpic1@2x.png")} 2x,${require("img/Products/riskpic1@3x.png")} 3x`
        },
        {
          title: '工程管理审计',
          data: '工程管理审计是对重点建设项目开展阶段性的管理审计与评价。 一方面督促项目公司严格管理，有效履职；另一方面，发现项目管控中存在的薄弱环节，提出改进意见及建议，帮助过程纠偏， 保障建设项目工期、质量、投资控制目标的实现。我们连续多年配合国资委实施集中重点检查工作，洞悉国家的相关政策法规，以及国家审计及国资委的监管重点，可以更好的保证审计质量。',
          imgPath: require("img/Products/riskpic2.png"), imgHDPath: `${require("img/Products/riskpic2.png")} 1x,${require("img/Products/riskpic2@2x.png")} 2x,${require("img/Products/riskpic2@3x.png")} 3x`
        },
        {
          title: '建设项目后评价',
          data: '建设项目后评价在项目竣工投产后展开，对建设项目的决策管理、实施管理、运营管理进行全面总结、评价，检验预期的投资收益和目标是否达到，对比实施效果与预期目标的偏差，并分析其原因，总结项目成功的经验和失败的教训，为后续投资提供借鉴。',
          imgPath: require("img/Products/riskpic3.png"), imgHDPath: `${require("img/Products/riskpic3.png")} 1x,${require("img/Products/riskpic3@2x.png")} 2x,${require("img/Products/riskpic3@3x.png")} 3x`
        },
        {
          title: '项目群成本与招采检查',
          data: '项目群定期体检一般为接受集团相关部门委托，对其下属建设项目管理的合法合规性、合理性、有效性开展的周期性专项检查或者综合性检查。作为最早为房地产客户提供成本、招采第三方检查业务的造价咨询机构之一，我们是行业内项目群检查业绩最多的咨询机构。',
          imgPath: require("img/Products/riskpic4.png"), imgHDPath: `${require("img/Products/riskpic4.png")} 1x,${require("img/Products/riskpic4@2x.png")} 2x,${require("img/Products/riskpic4@3x.png")} 3x`
        },
      ],
      caseList: [
        { imgs: require("img/Products/riskcase1.png"), name: "中国医学科学院阜外医院" },
        { imgs: require("img/Products/riskcase2.png"), name: "国电集团" },
        { imgs: require("img/Products/riskcase3.png"), name: "阿里巴巴" },
        { imgs: require("img/Products/riskcase4.png"), name: "华北石化" },
        { imgs: require("img/Products/riskcase5.png"), name: "中粮置地" },
      ]
    }
  }
  render() {
    return (
      <main>
        <HeaderSwiper headerDataLists={this.state.headerDataLists}></HeaderSwiper>
        <div className="risk">
          <h5 className='product-title'>服务内容</h5>
          <Lists dataLists={this.state.dataLists}></Lists>
          {/* <h5 className="product-title">相关案例</h5> */}
          <RelatedCases caseList={this.state.caseList} id={'Risk'}/>
        </div>
      </main>
    )
  }
}
export default Risk
